import { CaseStatus, } from '@debbie/common/dist/cases/index.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import 'react-select-v1/dist/react-select.css';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Panel } from '../index.js';
import UserPreview from '../performed-by/UserPreview.js';
import HistItem from './HistItem.js';
const CaseStatusItem = (props) => {
    const lang = useSelector((s) => s.lang);
    const endReasons = useEndReasons();
    const endReasonLookup = h.hasData(endReasons)
        ? objectBy(endReasons.data, (er) => er.id)
        : {};
    if (!props.date) {
        return null;
    }
    if (props.data.status === CaseStatus.PENDING) {
        return null;
    }
    const endReason = props.data.endReasonId
        ? endReasonLookup[props.data.endReasonId]
        : null;
    return (React.createElement(HistItem, { date: props.date, timespan: props.timespan, heading: React.createElement("span", null,
            props.data.createdByUserId && (React.createElement(UserPreview, { id: props.data.createdByUserId })),
            ' ',
            props.data.status === CaseStatus.VERIFIED
                ? lang.cases.case + ' ' + lang.cases.VERIFIED
                : lang.cases.case + ' ' + lang.cases.ENDED) }, endReason && (React.createElement(Panel, null, lang.endReason[endReason.handle] ??
        endReason.label))));
};
export default CaseStatusItem;
//# sourceMappingURL=CaseStatusItem.js.map